<template>
  <div class="crud_module--rsr_start_charger">
    <Popup ref="rsr_popup">
      <div class="rsr_popup">
        <div class="content" v-loading="loading">
          <div class="row">
            <div class="field">
              <div class="label-group">
                <label class="label">{{ $t("field.general.id") }}</label>
                <input disabled="disabled" v-model="id" type="text" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="field">
              <div class="label-group">
                <label class="label">{{ $t("field.cp_rsr.external_account_id") }}</label>
                <input v-model="input.memberId" type="text" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="field">
              <div class="label-group">
                <label class="label">{{ $t("label.connector_id") }}</label>
                <select v-model="input.connectorId">
                  <option
                    v-for="opt in connectors"
                    :value="opt.connector_id"
                    :key="opt.name"
                  >
                    {{getOptionValue(opt)}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="field">
              <div class="label-group">
                <label class="label">{{ $t("label.duration") }}</label>
                <input v-model="input.time" type="number" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="field">
              <div class="label-group">
                <label class="label">{{ $t("label.remark") }}</label>
                <textarea rows="5" v-model="input.remark"></textarea>
              </div>
            </div>
          </div>
          <!-- <div class="row">
            <div class="field">
              <div class="label-group">
                <label class="label">{{ $t("label.start_code") }}</label>
                <input v-model="input.startCode" type="text" />
              </div>
            </div>
          </div> -->
          <div class="row">
            <div class="field">
              <div>
                {{ $t("label.is_free") }} <input v-model="input.isFree" disabled="disabled" type="checkbox" true-value="Y" false-value="N" />
              </div>
            </div>
          </div>
          <!-- <div class="row">
            <div class="field">
              <div class="label-group">
                <label class="label">{{ $t("label.lp") }}</label>
                <input v-model="input.lp" type="text" disabled="disabled" />
              </div>
            </div>
          </div> -->
          <div class="row">
            <div class="field">
              <div class="label-group">
                <label class="label">{{ $t("label.entry_time") }}</label>
                <input
                  v-model="input.entryTime"
                  type="text"
                  disabled="disabled"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="action-btn">
          <el-button type="primary" @click="confirm">{{
            $t("button.confirm")
          }}</el-button>
        </div>
      </div>
    </Popup>
    <el-button
      
      type="info"
      @click="rsrStartCharger"
      >{{ $t("label.start_charger") }}</el-button
    >
  </div>
</template>

<script>
export default {
  props: ["data"],
  components: {},
  async beforeMount() {
    this.key = this.$route.params.key;
    this.id = this.$route.params.id;
    // this.loading = true;
    // // console.log(this.data);
    // await this.fetchData();
    // this.loading = false;

    // this.show_chart = true;
  },
  methods: {
    async refresh() {
      // await this.fetchData();
      // this.$refs.chart.reload();
    },
    getOptionValue(opt){
      if (opt?.name){
        return opt.name;
      }
      return opt.connector_id;
    },
    async rsrStartCharger() {
      let action = this.$t("label.start_charger");
      let message = this.$t("message.confirm_start_charger", {action : action});
      let confirm = await this.$confirm(message, message, {
        confirmButtonText: action,
        cancelButtonText: "取消",
        type: "warning",
      });
      if (!confirm) return;

      // this.selected = id;
      this.$store.commit("control/setLoad", true);
      await this.$axios
        .get(`/${this.key}/getLp/${this.id}`, {})
        .then((res) => {
          console.log(res);
          if (res.data?.status == "success") {
            const obj = JSON.parse(res.data.data);
            console.log(obj);
            if (obj.ResCode == 0) {
              console.log('rescode = 0')
              this.input.lp = obj.LPN;
              this.input.entryTime = obj.EntryTime;
              this.connectors = this.data.cp_connectors;
              this.$refs.rsr_popup.show();
            } else {
              this.$message({
                message: obj.ResMsg,
                type: "error",
              });
            }
          } else if (res.data?.status == "error") {
            this.$message({
              message: this.$t(`error.${res.data?.errorCode}`),
              type: "error",
            });
          } else {
            this.$message({
              message: this.$t("error.generic"),
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err?.response?.data);
          if (err?.response?.data?.errors) {
            this.errors = err.response.data.errors;
          }
          if (err?.response?.data?.fields) {
            this.error_fields = err.response.data.fields;
          }
          this.$message({
            message: this.$t("error.generic"),
            type: "error",
          });
          return false;
        });
      this.$store.commit("control/setLoad", false);
    },
    checkChargingStatusCode() {
      if (
        this.data?.charging_status_code?.charging_status_code != "Charging" &&
        this.data?.charging_status_code?.charging_status_code != "SuspendedEVSE" &&
          this.data?.charging_status_code?.charging_status_code != "SuspendedEV"

      ) {
        return true;
      }
      return false;
    },
    async fetchData() {
      this.connectors = this.data.cp_connectors;
      // console.log(this.data.cp_connectors);
      // await this.$axios.get(`/${this.key}/${this.id}`, {}).then(res=>{
      //   let data = res.data;
      //   // console.log("test");
      //   // console.log(data);
      //   this.connectors = data.cp_connectors;
      //   // this.rows = data;
      // }).catch(err=>err);
    },
    async confirm() {
      this.loading = true;
      await this.$axios
        .post(`/${this.key}/rsrStartCharger/${this.id}`, {
          ...this.input,
        })
        .then((res) => {
          if (res.data?.status == "success") {
            this.$message({
              message: this.$t("success"),
              type: "success",
            });
            this.$refs.rsr_popup.close();
          } else if (res.data?.status == "error") {
            this.$message({
              message: this.$t(`error.${res.data?.errorCode}`),
              type: "error",
            });
          } else {
            this.$message({
              message: this.$t("error.generic"),
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err?.response?.data);
          if (err?.response?.data?.errors) {
            this.errors = err.response.data.errors;
          }
          if (err?.response?.data?.fields) {
            this.error_fields = err.response.data.fields;
          }
          this.$message({
            message: this.$t("error.generic"),
            type: "error",
          });
          return false;
        });
      this.loading = false;
    },
  },
  data() {
    return {
      key: "",
      id: 0,
      loading: false,
      connectors: [],
      input: {
        connectorId: 0,
        time: 0,
        startCode: "",
        lp: "",
        entryTime: "",
        isFree:"Y",
        remark:"",
        memberId:""
      },
    };
  },
};
</script>

<style lang="scss">
.crud_module--rsr_start_charger {
  display: inline-block;
  margin-top: 10px;
  .el-button--info {
    background-color: #909399;
  }
  .rsr_popup {
    padding: 20px;
    height: 80vh;
    width: 40vw;
    background: white;
    // overflow-y: auto;
    .action-btn {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      .export-btn {
        display: flex;
        justify-content: flex-end;
      }
    }
    .content {
      // padding: 20px;
      .detail {
        .item {
          font-size: 12px;
          margin-bottom: 10px;
          .data {
            width: 100%;
            display: flex;
          }
          .label {
            width: 130px;
            min-width: 130px;
            display: flex;
            align-items: center;
          }
          .data {
            .value {
              min-width: 200px;
              width: 100%;
              border: 1px solid gray;
              background-color: #e6e6e6 !important;
              padding: 3px 5px;
            }
          }
        }
      }
      .row {
        display: flex;
        width: 100%;
        margin-bottom: 10px;
        & > .field {
          flex-grow: 1;
          // width: 100%;
          max-width: 100%;
          & > :first-child {
            margin-right: 5px;
          }
          &:not(:first-child) {
            margin-left: 5px;
          }
        }

        .label-group,
        .control-group {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .label {
            // width: 150px;
            // min-width: 150px;
          }
          input:not([type="checkbox"]) {
            height: 30px;
            // width: 100%;
          }
          select {
            height: 30px;
            padding: 1px 2px;
          }
          textarea {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
